import React, { useCallback, useContext } from "react";
import { useSubscribeExportPolling } from "@weezevent/gofast-front";
import { ToastContext } from "@weezevent/nacre";
import { ToastMessageWithCta } from "../generic/toastMessage";
import { useTranslation } from "react-i18next";

export const GoFastExportNotifications = () => {
	const { t } = useTranslation();
	const { success } = useContext(ToastContext);

	const showNotification = useCallback(
		({ dest, status }) => {
			if (status === "done") {
				success(
					<ToastMessageWithCta
						className="toast-success"
						text={t("access.common.exportFinished")}
						cta={t("access.common.exportDownloadButton")}
						onClick={() => {
							window.open(dest, "_blank");
						}}
					/>
				);
			}
		},
		[success, t]
	);

	useSubscribeExportPolling(showNotification);

	return null;
};
